import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type {
  ApiSuccess,
  EinvoiceSettingInput,
  EinvoiceSettingView,
} from '@app/shared';
import { apiClient } from '../../lib/api-client';

const KEY = ['settings', 'einvoice'];

export function useEinvoiceSetting() {
  return useQuery({
    queryKey: KEY,
    queryFn: async (): Promise<EinvoiceSettingView> => {
      const res = await apiClient.get<ApiSuccess<EinvoiceSettingView>>('/settings/einvoice');
      return res.data.data;
    },
  });
}

export function useUpdateEinvoice() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: EinvoiceSettingInput): Promise<EinvoiceSettingView> => {
      const res = await apiClient.put<ApiSuccess<EinvoiceSettingView>>('/settings/einvoice', input);
      return res.data.data;
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: KEY });
    },
  });
}
